import config from '../config/config';

var api = {

  // Post Project API
  postProject(projectName) {
    var url = config.apiDomain + '/project';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          project_name: projectName
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Projects List API
  getProjects() {
    var url = config.apiDomain + '/projects';
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Post Document Type API
  postDocumentType(documentType) {
    var url = config.apiDomain + '/document_type';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          document_type: documentType
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Document Types List API
  getDocumentTypes() {
    var url = config.apiDomain + '/document_types';
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Post New Currency Type API
  postCurrencyType(currencyType) {
    var url = config.apiDomain + '/currency_type';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          currency_type: currencyType
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Currency Type List API
  getCurrencyTypes() {
    var url = config.apiDomain + '/currency_types';
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Post New Vendor API
  postNewVendor(vendorCode, vendorName, vendorContact, vendorAddress) {
    var url = config.apiDomain + '/vendors';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          vendor_code: vendorCode,
          vendor_name: vendorName,
          vendor_contact_number: vendorContact,
          vendor_address: vendorAddress
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Vendors List API
  getVendors() {
    var url = config.apiDomain + '/vendors';
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Post New User Dept API
  postUserDept(userDept) {
    var url = config.apiDomain + '/user_department';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          user_department: userDept
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get User Depts List API
  getUserDepts() {
    var url = config.apiDomain + '/user_departments';
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Post New Consignment API
  postConsignment(consignmentNature) {
    var url = config.apiDomain + '/consignment';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          consignment: consignmentNature
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Consignments List API
  getConsignments() {
    var url = config.apiDomain + '/consignments';
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Post Document API
  postDocument(companyCode, vhdReceivedDate, gateEntryNo, gateEntryDate, sapGateEntryNo, sapGateEntryDate, pcDcNo, pcDcDate, project, 
               documentType, natureOfConsignment, boeNo, boeDate, lrNo, currencyType, invoiceAmount, exchangeRate, amount, invoiceNo, 
               invoiceDate, vendor, poNo, poDate, poAmount, creditPeriod, userDepartment, userName, itemDescription) {
    var url = config.apiDomain + '/document';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          company_code: companyCode,
          vhd_received_date: vhdReceivedDate,
          gate_entry_no: gateEntryNo,
          gate_entry_date: gateEntryDate,
          sap_gate_entry_no: sapGateEntryNo,
          sap_gate_entry_date: sapGateEntryDate,
          pc_no_dc_no: pcDcNo,
          pc_dc_date: pcDcDate,
          project: project,
          document_type: documentType,
          nature_of_consignment: natureOfConsignment,
          boe_no: boeNo,
          boe_date: boeDate,
          lr_no: lrNo,
          currency_type: currencyType,
          amt_invoice_currency: invoiceAmount,
          exchange_rate: exchangeRate,
          amt_inr: amount,
          invoice_no: invoiceNo,
          invoice_date: invoiceDate,
          vendor_id: vendor,
          po_no: poNo,
          po_date: poDate,
          po_amount: poAmount,
          credit_period: creditPeriod,
          item_description: itemDescription,
          user_dept: userDepartment,
          user_name: userName,
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Consignments List API
  getDocumentList(companyCode) {
    var url = config.apiDomain + '/documents?company_code='+ companyCode;
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Bulk Documents API
  getBulkDocuments(companyCode, documentList) {
    var url = config.apiDomain + '/bulk_documents';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          company_code: companyCode,
          documents: documentList
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  //Put Bulk Documents Update API
  putBulkDocumentsUpdate(companyCode, bulkDocumentList) {
    var url = config.apiDomain + '/bulk_documents';
    return fetch(
      url,
      {
        method: 'put',
        body: JSON.stringify({
          company_code: companyCode,
          documents: bulkDocumentList
         }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==', 
        }
      }
    );
  },

  // Get Document Details API
  getDocumentDetailss(companyCode, documentNumber) {
    var url = config.apiDomain + '/documents?company_code='+companyCode+'&doc_control_num='+documentNumber;
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Post New Document Status API
  postDocumentStatus(docStatus) {
    var url = config.apiDomain + '/document_status';
    return fetch(
      url,
      {
        method: 'post',
        body: JSON.stringify({
          document_status: docStatus
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get User Depts List API
  getCurrentStatus() {
    var url = config.apiDomain + '/document_status';
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Put Document API
  putDocument(companyCode, documentNumber, vhdReceivedDate, gateEntryNo, gateEntryDate, sapGateEntryNo, sapGateEntryDate, pcDcNo, pcDcDate, project, 
              documentType, natureOfConsignment, boeNo, boeDate, lrNo, currencyType, invoiceAmount, exchangeRate, amount, invoiceNo, 
              invoiceDate, vendor, poNo, poDate, poAmount, creditPeriod, userDepartment, userName, itemDescription, inboundDeliveryNumber,
              inboundDeliveryDate, sapGrnNo, grnDate, noOfLinesInGr, sentToQcOn, recdFromQcOn, sentToUserOn, recdFromUserOn, userCertifiedAmount,
              submittedToFinOn, irNo, irDate, paymentDocumentNo, paymentDocumentDate, amountPaid, chqRtgsNo, chqDate, returnedFromFinOn, returnToVendor,
              dueDate, department, currentStatus, statusDate, tds, wct, advanceAdj, retention, otherDed, remarks, financeRemarks) {
    var url = config.apiDomain + '/document';
    return fetch(
      url,
      {
        method: 'put',
        body: JSON.stringify({
          company_code: companyCode,
          document_control_no: documentNumber,
          vhd_received_date: vhdReceivedDate,
          gate_entry_no: gateEntryNo,
          gate_entry_date: gateEntryDate,
          sap_gate_entry_no: sapGateEntryNo,
          sap_gate_entry_date: sapGateEntryDate,
          pc_no_dc_no: pcDcNo,
          pc_dc_date: pcDcDate,
          project: project,
          document_type: documentType,
          nature_of_consignment: natureOfConsignment,
          boe_no: boeNo,
          boe_date: boeDate,
          lr_no: lrNo,
          currency_type: currencyType,
          amt_invoice_currency: invoiceAmount,
          exchange_rate: exchangeRate,
          amt_inr: amount,
          invoice_no: invoiceNo,
          invoice_date: invoiceDate,
          vendor_id: vendor,
          po_no: poNo,
          po_date: poDate,
          po_amount: poAmount,
          credit_period: creditPeriod,
          item_description: itemDescription,
          user_dept: userDepartment,
          user_name: userName,
          inbound_delivery_number : inboundDeliveryNumber,
          inbound_delivery_date : inboundDeliveryDate,
          sap_grn_no : sapGrnNo,
          grn_date : grnDate,
          no_of_lines_in_gr : noOfLinesInGr,
          sent_to_qc_on : sentToQcOn,
          recd_from_qc_on : recdFromQcOn,
          sent_to_user_on : sentToUserOn,
          recd_from_user_on : recdFromUserOn,
          user_certified_amount : userCertifiedAmount,
          submitted_to_fin_on : submittedToFinOn,
          ir_no : irNo,
          ir_date : irDate,
          payment_document_no : paymentDocumentNo,
          payment_document_date : paymentDocumentDate,
          amount_paid : amountPaid,
          chq_rtgs_no : chqRtgsNo,
          chq_date : chqDate,
          returned_from_fin_on : returnedFromFinOn,
          return_to_vendor : returnToVendor,
          due_date : dueDate,
          department : department,
          current_status : currentStatus,
          status_date : statusDate,
          remarks : remarks,
          finance_remarks : financeRemarks,
          tds : tds,
          wct : wct,
          advance_adj : advanceAdj,
          retention: retention,
          other_ded: otherDed
        }),
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

  // Get Audit Report list API
  getAuditReportList(companyCode, documentNumber) {
    var url = config.apiDomain + '/audit_report?company_code='+companyCode+'&document_control_no='+documentNumber;
    return fetch(
      url,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'idtoken': '3oQffPpJ1FoKzYfLtcanxw==',
        }
      }
    );
  },

};

export default api;


// WEBPACK FOOTER //
// ./src/api/api.js